// Mirror of resolveCrmContactEmail for HubSpot contact ids: real contacts are
// used by default and the shared dev test contact is opt-in via useTestContact.
// This id is the HubSpot id of DEV_TEST_CONTACT_EMAIL — keep them in sync.
const DEV_TEST_CONTACT_ID = '27827201';

export type ResolveCrmContactIdParams = {
	realContactId: string;
	environment?: string;
	useTestContact?: boolean;
};

export const resolveCrmContactId = (params: ResolveCrmContactIdParams): string => {
	const { realContactId, environment, useTestContact = false } = params;
	return useTestContact && environment !== 'LIVE' ? DEV_TEST_CONTACT_ID : realContactId;
};
